/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
window.addEventListener("DOMContentLoaded", e => {
  const starRatingEl = document.querySelector('a[href="#looxReviewsFrame"]');
  if(starRatingEl){
    const starRatingCopyContainerEl = document.querySelector('[data-star-rating-copy]');
    if (!starRatingEl && !starRatingCopyContainerEl) return;
    const starRatingLabel = starRatingEl.querySelector('.loox-rating-label')?.textContent;
    starRatingCopyContainerEl.innerHTML = starRatingEl.outerHTML;
    if (starRatingCopyContainerEl.querySelector('.loox-rating-label') && starRatingLabel){
      starRatingCopyContainerEl.querySelector('.loox-rating-label').textContent = starRatingLabel.split(' ')[0];
    }
  }
});

// Including margins
function getHeaderHeight() {
  const headerEl = document.querySelector('header');
  const headerStyle = window.getComputedStyle(headerEl);
  const headerHeight = headerEl.offsetHeight;
  const headerMarginBotom = parseFloat(headerStyle.marginBottom);
  return headerHeight + headerMarginBotom;
}

function setupTopbarScrollHandler() {
  if (window.innerWidth < 1000) {
    const topbarEl = document.querySelector('.cb-collection-topbar');
    if (!topbarEl) return;
    let lastScrollTop = 0;
    let isSliding = false;
    const stickyTop = topbarEl.getBoundingClientRect().top;

    function handleScroll() {
      let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      const rect = topbarEl.getBoundingClientRect();
      
      if (currentScroll > lastScrollTop) {
        if (rect.top <= getHeaderHeight() && !isSliding) {
          isSliding = true;
          topbarEl.classList.add('-cb-translateY-full');
        }
      } else if (currentScroll < lastScrollTop) {
        if (currentScroll >= stickyTop && isSliding) {
          isSliding = false;
          topbarEl.classList.remove('-cb-translateY-full');
        }
      }
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      eventInit = true;
    }
    window.addEventListener('scroll', handleScroll);
  }
}
setupTopbarScrollHandler();

document.addEventListener('theme:loading:end', (event) => {
  setupTopbarScrollHandler();
  // setupSearchBarScrollHandler();
});

// update discount label on 1209774263414583
document.addEventListener('variant:changed', e => {
  const compareAtPrice = +e.detail.variant.compare_at_price;
  const labelEl = document.querySelector('.product-label--on-sale');
  const discounValueEl = document.querySelector('.cb-product-form-info-content .cb-discount-value');
  if (!compareAtPrice && !discounValueEl) return;
  const price = +e.detail.variant.price;
  const discount = (compareAtPrice - price) / 100;
  const currencySymbol = discounValueEl.dataset.currencySymbol;
  if(discount < 0) {
    labelEl.classList.add('hidden');
  } else {
    labelEl.classList.remove('hidden');
    discounValueEl.textContent = currencySymbol + "" + (discount.toFixed(2).replace('.', ','));
  }
});
// end update discount label on 1209774263414583

// 1209774263414583 start
const showHideSearchTrigger = document.querySelector('.cb-show-hide-search-wrapper');
if (showHideSearchTrigger) {
  showHideSearchTrigger.addEventListener('click', e => {
    const searchBar = document.querySelector('.header__search-bar-wrapper');
    if (searchBar) {
      searchBar.classList.toggle('is-visible');
    }
  });
}
// 1209774263414583 end